import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { INTEGRATION_ENABLED } from 'voxloud-types/dist/models/integrations';

@Component({
  selector: 'gdp-select-integration-enabled',
  templateUrl: './select-integration-enabled.component.html',
  styleUrls: ['./select-integration-enabled.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectIntegrationEnabledComponent),
      multi: true
    }
  ]
})
export class SelectIntegrationEnabledComponent implements ControlValueAccessor {
  public INTEGRATION_ENABLED: string[] = INTEGRATION_ENABLED;
  public selectedIntegrationEnabled: string = this.INTEGRATION_ENABLED[0]

  onChange: any = () => { }
  onTouch: any = () => { }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(val: string) {
    if (val && INTEGRATION_ENABLED.includes(val)) {
      this.selectedIntegrationEnabled = val;
    } else {
      this.selectedIntegrationEnabled = 'false';
    }
  }

  public selectIntegrationEnabled(value: string) {
    this.selectedIntegrationEnabled = value;
    this.onChange(value);
  }
}
